/*
 * @Author: xuzf
 * @Date: 2021-01-20 11:40:57
 * @LastEditors: xuzf
 * @LastEditTime: 2021-02-28 15:32:02
 */
// 适配 Nginx 反向代理
var baseUrl = process.env.VUE_APP_BASE_API === '/' ? '' : process.env.VUE_APP_BASE_API;
var api = {
  state: {
    // 部署包上传
    deployUploadApi: baseUrl + 'api/deploy/upload',
    // SQL脚本上传
    databaseUploadApi: baseUrl + 'api/database/upload',
    // 实时控制台
    socketApi: baseUrl + '/websocket?token=kl',
    // 图片上传
    imagesUploadApi: baseUrl + 'api/localStorage/pictures',
    // 修改头像
    updateAvatarApi: baseUrl + 'api/users/updateAvatar',
    // 上传文件到七牛云
    qiNiuUploadApi: baseUrl + 'api/qiNiuContent',
    // Sql 监控
    sqlApi: baseUrl + '/druid/index.html',
    // swagger
    swaggerApi: baseUrl + '/swagger-ui.html',
    // 文件上传
    fileUploadApi: baseUrl + 'api/localStorage',
    // baseUrl，
    baseApi: baseUrl
  }
};
export default api;